import React from "react";
import Form from "react-bootstrap/Form";
import PropTypes from "prop-types";
import "./TeamOption.scss";

const TeamOption = ({ name, label, selected, onChange, isValid }) => {
    const validation = isValid ? "noItemsSelected" : "teamSizeSelected";
    return (
        <div className={`radio-size-container ${selected ? "selected" : ""} ${validation}`}
            onClick={() => onChange(name) } >
            <Form.Label className={`radio-size-label ${name}-label`}>{name}</Form.Label>
            <Form.Check
                value={name}
                className={`radio-size radio-size${name}`}
                type='radio'
                aria-label={`radio ${name}`}
                onChange={(e) => onChange(e.target.value)}
                checked={selected}
            />
            <p className={`radio-size-sub-label ${name}-sub-label`}>{label}</p>
            <div className={`radio-size-icon radio-size-icon-${name}`}></div>
        </div>
    );
};

TeamOption.propTypes = {
    name: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    selected: PropTypes.bool,
    onChange: PropTypes.func.isRequired,
    isValid: PropTypes.bool.isRequired,
}

export default TeamOption;